const SYMPTOMS = {
    content: 'symptom'
}

import hasCount from './util/has-count'

export default {
    option: {
        value: 'symptom',
        label: 'Symptom',
        show: true,

        children: [
            {
                value: 'symptom-includes-any',
                label: 'Reported any of',
                select: SYMPTOMS,

                match: hasCount({ type: 'symptom' })
            },
            {
                value: 'symptom-includes',
                label: 'Reported all of',
                select: SYMPTOMS,

                match: hasCount({ type: 'symptom' })
            },
            {
                value: 'not-syptom-includes',
                label: 'Did not report',
                select: SYMPTOMS,

                match: hasCount({ type: 'symptom', not: true })
            }
        ]
    }
}
